import React from "react";
import { useLang, IMAGES } from "../i18n";
import { Reveal, SectionLabel, MaskLine } from "./Motion";
import { motion } from "framer-motion";

export const About = () => {
  const { t } = useLang();
  const a = t.about;
  return (
    <section id="about" data-testid="about-section" className="relative py-20 md:py-40">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-7">
          <SectionLabel>{a.label}</SectionLabel>
          <h2 className="font-cormorant italic font-light text-3xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight max-w-2xl text-[var(--text-primary)]">
            <MaskLineViewport text={a.quote} />
          </h2>

          <div className="mt-12 space-y-6 max-w-xl">
            {[a.p1, a.p2, a.p3].map((p, i) => (
              <Reveal key={i} delay={i * 0.1}>
                <p className="font-outfit font-light text-[var(--text-secondary)] leading-relaxed">{p}</p>
              </Reveal>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5">
          <Reveal delay={0.2}>
            <div className="relative rounded-2xl overflow-hidden border border-[var(--border)] group">
              <img
                src={IMAGES.digitalTwin}
                alt="Digital Twin"
                className="w-full h-[440px] object-cover transition-transform duration-[1.2s] group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[var(--bg-primary)] via-[var(--bg-primary)]/20 to-transparent" />
              <div className="absolute bottom-6 left-6 right-6">
                <div className="font-jetbrains text-[10px] tracking-[0.2em] text-[var(--gold)] uppercase mb-2">
                  Digital Twin · Blockchain
                </div>
                <div className="font-cormorant text-2xl text-[var(--text-primary)]">
                  {t.footer.tagline}
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

const MaskLineViewport = ({ text }) => (
  <span className="block overflow-hidden">
    <motion.span
      initial={{ y: "110%" }}
      whileInView={{ y: "0%" }}
      viewport={{ once: true }}
      transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
      className="block"
    >
      "{text}"
    </motion.span>
  </span>
);
